module.exports = __webpack_public_path__ + "img/A_talk.3d04a8da.gif";